import WiringInfoModal from "./WiringInfoModal";

export default WiringInfoModal;